module.exports = __webpack_public_path__ + "static/Ginger.87324169.png";